import React, { useState, useEffect, useCallback } from 'react';
import hero1 from '../hero-1.jpg';
import hero2 from '../hero-2.jpg';
import hero3 from '../hero-3.jpg';
import aboutImg from '../aboutme.png';
import logo from '../logolumi.png';
import './Hero.css';

const slides = [
  {
    image: hero1,
    label: 'Stöd till skolor',
    description: 'Kuratorsstöd, sociala bedömningar och samtal med elever i samverkan med elevhälsoteam.',
  },
  {
    image: hero2,
    label: 'Ungdomsarbete',
    description: 'Stöd i verksamheter som stärker ungdomars delaktighet, trygghet och utveckling.',
  },
  {
    image: hero3,
    label: 'Föreläsningar',
    description: 'Om normer, kultur och socialisation — bygger på boken Slöjan, en kulturhistoria.',
  },
];

function Hero() {
  const [active, setActive] = useState(0);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const next = useCallback(() => {
    setActive((prev) => (prev + 1) % slides.length);
  }, []);

  useEffect(() => {
    const interval = setInterval(next, 5000);
    return () => clearInterval(interval);
  }, [next]);

  const slide = slides[active];

  return (
    <section id="hero" className="hero">
      <div className={`hero__left ${loaded ? 'hero__left--visible' : ''}`}>
        <div className="hero__content">
          <h1 className="hero__title">
            <span className="hero__title-line">Trygghet, stöd och</span>
            <span className="hero__title-line">
              utveckling för{' '}
              skolor
            </span>
            <span className="hero__title-line hero__title-line--accent">
              &amp;{' '}
              ungdomar
              <img src={aboutImg} alt="Hafize Cetin" className="hero__inline-avatar" />
            </span>
          </h1>
          <p className="hero__description">
            Hafize Cetin Konsult erbjuder professionellt stöd till skolor, barn
            och ungdomar genom samtal, social kartläggning, föreläsningar och
            elevhälsoarbete — alltid i nära samverkan.
          </p>
          <div className="hero__actions">
            <a href="#contact" className="hero__btn hero__btn--primary">Kom i kontakt</a>
            <a href="#services" className="hero__btn hero__btn--text">
              Alla tjänster
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </a>
          </div>

          <div className="hero__bottom">
            <div className="hero__bottom-logos">
              <img src={logo} alt="LumiMind" className="hero__bottom-logo" />
              <span className="hero__bottom-brand">Hafize Cetin Konsult</span>
            </div>
            <p className="hero__bottom-text">
              Beteendevetare, skolkurator (2017–2023) och författare till
              boken Slöjan — en kulturhistoria.
            </p>
          </div>
        </div>
      </div>

      <div className={`hero__right ${loaded ? 'hero__right--visible' : ''}`}>
        {slides.map((s, i) => (
          <img
            key={i}
            src={s.image}
            alt={s.label}
            className={`hero__image ${i === active ? 'hero__image--active' : ''}`}
          />
        ))}

        {/* Single glassy card */}
        <div className="hero__glass-card" key={active}>
          <div className="hero__glass-images">
            <div className="hero__glass-img hero__glass-img--back">
              <img src={slides[(active + 1) % slides.length].image} alt="" />
            </div>
            <div className="hero__glass-img hero__glass-img--front">
              <img src={slide.image} alt="" />
            </div>
          </div>
          <div className="hero__glass-content">
            <p className="hero__glass-label">{slide.label}</p>
            <p className="hero__glass-desc">{slide.description}</p>
          </div>
          <div className="hero__glass-meta">
            <span className="hero__glass-count">{active + 1}/{slides.length}</span>
            <div className="hero__glass-progress">
              <svg width="24" height="24" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="2" />
                <circle
                  cx="12" cy="12" r="10" fill="none" stroke="white" strokeWidth="2"
                  strokeDasharray="62.83"
                  strokeDashoffset={62.83 - (62.83 * ((active + 1) / slides.length))}
                  strokeLinecap="round"
                  style={{ transition: 'stroke-dashoffset 0.5s ease', transform: 'rotate(-90deg)', transformOrigin: 'center' }}
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Nav dots */}
        <div className="hero__dots">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`hero__dot ${i === active ? 'hero__dot--active' : ''}`}
              onClick={() => setActive(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Hero;
